module.exports = __webpack_public_path__ + "img/ico-13.ee5e86ca.svg";